import { render, staticRenderFns } from "./widgetButton.vue?vue&type=template&id=2b5263d4&scoped=true"
import script from "./widgetButton.vue?vue&type=script&lang=js"
export * from "./widgetButton.vue?vue&type=script&lang=js"
import style0 from "./widgetButton.vue?vue&type=style&index=0&id=2b5263d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5263d4",
  null
  
)

export default component.exports